import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/dashboard/DashboardShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/BreakingNewsPageContent.tsx");
